import * as React from "react";
import dayjs from "dayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import Box from "@mui/material/Box";

export default function BasicDatePicker({
  val,
  onChange,
  label,
  Outsidelabel = null,
  required = false,
  ...restProps
}) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Box sx={{ flex: 1 }}>
        {Outsidelabel}
        <DemoContainer components={["DatePicker"]}>
          <DesktopDatePicker
            label={label}
            value={dayjs(val)}
            onChange={(newValue) => onChange(newValue)}
            slotProps={{
              textField: {
                required,
              },
            }}
            {...restProps}
          />
        </DemoContainer>
      </Box>
    </LocalizationProvider>
  );
}
